import { render, staticRenderFns } from "./LoadingTemplate.vue?vue&type=template&id=4c3c5b58&scoped=true"
import script from "./LoadingTemplate.vue?vue&type=script&lang=js"
export * from "./LoadingTemplate.vue?vue&type=script&lang=js"
import style0 from "./LoadingTemplate.vue?vue&type=style&index=0&id=4c3c5b58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3c5b58",
  null
  
)

export default component.exports